import request from '@/libs/request'

// 登录
export function login(data) {
  return request.post(`user/login`,data,{message:'请求中'})
}
// 登出
export function logout() {
  return request.get(`user/logout`)
}
// 获取用户信息
export function getInfo() {
  return request.get(`user/getInfo`)
}



// WEBPACK FOOTER //
// ./src/api/user.js